import { IQuestionModel } from '@care-portals/api-interfaces';

const questionsModels: IQuestionModel[] = [
  {
    label: 'History Form',
    educationalSlide: `
      Here at Momwell, we understand your time is precious. Please complete our online history form before your first appointment to ensure a smooth initial session. It will take <b> 10-20 minutes </b> to complete, but here’s the good news:
      <br />
      <ul>
      <li>You only need to complete this form once.</li>
      <li>Your information is completely confidential.</li>
      <li>The form saves automatically, so you can complete it at your own pace, in one sitting or multiple sessions.</li>
      </ul>
      `,
    field: 'momwellPartnerHistoryFormIntro',
    type: 'info',
    answer: {}
  },
  {
    label: 'Contact Information',
    field: 'momwellPartnerHistoryFormContactInfo',
    type: 'info',
    answer: {
      type: 'list',
      items: [
        {
          label: 'First Name',
          type: 'text',
          placeholder: 'Please enter your first name',
          name: 'firstName',
          required: true,
          halfWidth: true
        },
        {
          label: 'Last Name',
          type: 'text',
          placeholder: 'Please enter your last name',
          name: 'lastName',
          required: true,
          halfWidth: true
        },
        {
          label: 'Preferred Name (if different)',
          type: 'text',
          placeholder: 'Please enter your preferred name',
          name: 'preferredName',
          optional: true,
          required: false,
          halfWidth: true
        },
        {
          label: 'Prefix/Title',
          type: 'single_select',
          level: 'child',
          field: 'prefix',
          halfWidth: false,
          options: [
            {
              key: 'prefix_mr',
              value: 'Mr.'
            },
            {
              key: 'prefix_ms',
              value: 'Ms.'
            },
            {
              key: 'prefix_mrs',
              value: 'Mrs.'
            },
            {
              key: 'prefix_dr',
              value: 'Dr.'
            },
            {
              key: 'prefix_other',
              value: 'Other (Please specify)',
              answer: {
                type: 'text',
                rows: 3,
                name: 'prefixOtherDesc',
                placeholder: ''
              }
            }
          ]
        },
        {
          label: 'Pronouns',
          type: 'single_select',
          level: 'child',
          field: 'pronouns',
          halfWidth: false,
          options: [
            {
              key: 'pronouns_he',
              value: 'He/Him.'
            },
            {
              key: 'pronouns_she',
              value: 'She/Her'
            },
            {
              key: 'pronouns_mrs',
              value: 'Mrs.'
            },
            {
              key: 'pronouns_they',
              value: 'They/Them'
            },
            {
              key: 'pronouns_other',
              value: 'Prefer to self-describe (Please specify)',
              answer: {
                type: 'text',
                rows: 3,
                name: 'pronounsOtherDesc',
                placeholder: ''
              }
            },
            {
              key: 'pronouns_preferNotToSay',
              value: 'Prefer not to say'
            }
          ]
        },
        {
          label:
            'Please select all that apply to your racial and/or ethnic background:',
          type: 'multi_select',
          level: 'child',
          field: 'ethnic',
          halfWidth: false,
          options: [
            {
              key: 'ethnic_black',
              value: 'Black or African American'
            },
            {
              key: 'ethnic_white',
              value: 'White or European American'
            },
            {
              key: 'ethnic_asian',
              value: 'Asian'
            },
            {
              key: 'ethnic_native',
              value: 'Native Hawaiian or Other Pacific Islander'
            },
            {
              key: 'ethnic_hispanic',
              value: 'Hispanic or Latino'
            },
            {
              key: 'ethnic_eastern',
              value: 'Middle Eastern or North African'
            },
            {
              key: 'ethnic_multiracial',
              value: 'Multiracial'
            },
            {
              key: 'ethnic_preferNotToAnswer',
              value: 'Prefer not to answer'
            },
            {
              key: 'ethnic_other',
              value: 'Other (Please specify)',
              answer: {
                type: 'text',
                rows: 3,
                name: 'ethnicOtherDesc',
                placeholder: ''
              }
            }
          ]
        },
        {
          label: 'Email',
          type: 'text',
          placeholder: 'Please enter your email',
          name: 'email',
          required: true,
          halfWidth: true
        },
        {
          label: 'Mobile Phone',
          type: 'text',
          placeholder: 'Please enter your mobile phone',
          name: 'mobilePhone',
          required: true,
          halfWidth: true
        },
        {
          label: 'Home Phone',
          type: 'text',
          placeholder: 'Please enter your home phone',
          name: 'homePhone',
          optional: true,
          required: false,
          halfWidth: true
        },
        {
          label: 'Country',
          type: 'text',
          placeholder: 'Please enter your country',
          name: 'country',
          required: true,
          halfWidth: true
        },
        {
          label: 'State/Province',
          type: 'text',
          placeholder: 'Please enter your state/province',
          name: 'state',
          required: true,
          halfWidth: true
        },
        {
          label: 'City',
          type: 'text',
          placeholder: 'Please enter your city',
          name: 'city',
          required: true,
          halfWidth: true
        },
        {
          label: 'Street Address',
          type: 'text',
          placeholder: 'Please enter your street address',
          name: 'address',
          required: true,
          halfWidth: false
        },
        {
          label: 'Postal Code/Zip Code',
          type: 'text',
          placeholder: '',
          name: 'postal',
          required: true,
          halfWidth: true
        },
        {
          label: 'Date of Birth',
          type: 'date',
          placeholder: '',
          name: 'dob',
          required: true,
          halfWidth: true
        },
        {
          label: 'How did you hear about us?',
          type: 'single_select',
          level: 'child',
          field: 'howDidYouHearAboutUs',
          halfWidth: false,
          options: [
            {
              key: 'howDidYouHearAboutUs_childinternetSearch',
              value: 'Internet Search'
            },
            {
              key: 'howDidYouHearAboutUs_friendOrFamily',
              value: 'Friend or Family'
            },
            {
              key: 'howDidYouHearAboutUs_doctorOrHealthcareProvider',
              value: 'Doctor or Healthcare Provider'
            },
            {
              key: 'howDidYouHearAboutUs_advertisement',
              value: 'Advertisement'
            },
            {
              key: 'howDidYouHearAboutUs_socialMedia',
              value: 'Social Media'
            },
            {
              key: 'howDidYouHearAboutUs_podcast',
              value: 'Podcast'
            },
            {
              key: 'howDidYouHearAboutUs_brandPartner',
              value: 'Brand Partner (Willow, Huckleberry, etc)'
            },
            {
              key: 'howDidYouHearAboutUs_other',
              value: 'Other (Please specify)',
              answer: {
                type: 'text',
                rows: 3,
                name: 'howDidYouHearAboutUsOtherDesc',
                placeholder: ''
              }
            }
          ]
        }
      ]
    }
  },
  {
    label: 'Emergency Contact Information',
    field: 'momwellPartnerHistoryFormEmergencyContactInformation',
    type: 'info',
    answer: {
      type: 'list',
      items: [
        {
          label: 'Emergency Contact Name:',
          type: 'text',
          placeholder: '',
          name: 'emergencyContactName',
          required: true,
          halfWidth: false
        },

        {
          label: 'Relationship',
          type: 'single_select',
          level: 'child',
          field: 'relationship',
          halfWidth: false,
          options: [
            {
              key: 'relationship_parent',
              value: 'Parent'
            },
            {
              key: 'relationship_spousePartner',
              value: 'Spouse/Partner'
            },
            {
              key: 'relationship_sibling',
              value: 'Sibling'
            },
            {
              key: 'relationship_child',
              value: 'Child'
            },
            {
              key: 'relationship_friend',
              value: 'Friend'
            },
            {
              key: 'relationship_other',
              value: 'Other (Please specify)',
              answer: {
                type: 'text',
                rows: 3,
                name: 'relationshipOtherDesc',
                placeholder: ''
              }
            }
          ]
        },
        {
          label: 'Emergency Contact Phone',
          type: 'text',
          placeholder: '',
          name: 'emergencyContactPhone',
          required: true,
          halfWidth: false
        },
        {
          label: 'Name of Closest Hospital/Emergency Room',
          type: 'text',
          placeholder: '',
          name: 'nameOfClosestHospitalEmergencyRoom',
          required: true,
          halfWidth: false
        },
        {
          label: 'Hospital Address',
          type: 'text',
          placeholder: '',
          name: 'hospitalAddress',
          required: true,
          halfWidth: false
        },
        {
          label: 'Hospital Telephone Number',
          type: 'text',
          placeholder: '',
          name: 'hospitalTelephoneNumber',
          required: true,
          halfWidth: false
        },
        {
          label: 'Name of the Closest Police Department',
          type: 'text',
          placeholder: '',
          name: 'nameOfTheClosestPoliceDepartment',
          required: true,
          halfWidth: false
        },
        {
          label: 'Police Department Address',
          type: 'text',
          placeholder: '',
          name: 'policeDepartmentAddress',
          required: true,
          halfWidth: false
        },
        {
          label: 'Police Department Phone Number',
          type: 'text',
          placeholder: '',
          name: 'policeDepartmentPhoneNumber',
          required: true,
          halfWidth: false
        }
      ]
    }
  },
  {
    label: 'Social & Relational Information',
    field: 'momwellPartnerHistoryFormSocialRelationalInformation',
    type: 'info',
    answer: {
      type: 'list',
      items: [
        {
          label: 'Marital/Relationship Status',
          type: 'single_select',
          level: 'child',
          field: 'maritalRelationshipStatus',
          halfWidth: false,
          options: [
            {
              key: 'momwellPartnerHistoryFormSocialRelationalInformation_single',
              value: 'Single'
            },
            {
              key: 'momwellPartnerHistoryFormSocialRelationalInformation_inARelationship',
              value: 'In a relationship'
            },
            {
              key: 'momwellPartnerHistoryFormSocialRelationalInformation_commonLaw',
              value: 'Common Law'
            },
            {
              key: 'momwellPartnerHistoryFormSocialRelationalInformation_separatedDivorced',
              value: 'Separated/Divorced'
            },
            {
              key: 'momwellPartnerHistoryFormSocialRelationalInformation_widowed',
              value: 'Widowed'
            }
          ]
        },

        {
          label:
            'Do you have other children? If yes, please enter their date of birth',
          type: 'single_select',
          level: 'child',
          field: 'doYouHaveOtherChildrenIfYesPleaseEnterTheirDateOfBirth',
          halfWidth: false,
          options: [
            {
              key: 'doYouHaveOtherChildrenIfYesPleaseEnterTheirDateOfBirth_no',
              value: 'No'
            },
            {
              key: 'doYouHaveOtherChildrenIfYesPleaseEnterTheirDateOfBirth_yes',
              value: 'Yes (Please list their date of birth)',
              answer: {
                type: 'list',
                items: [
                  {
                    label: 'Please list the date of birth of your first  child',
                    type: 'date',
                    name: 'doYouHaveOtherChildrenIfYesPleaseEnterTheirDateOfBirth_dob1',
                    optional: true,
                    required: false,
                    halfWidth: false
                  },
                  {
                    label: 'please list the date of birth of your second child',
                    type: 'date',
                    name: 'doYouHaveOtherChildrenIfYesPleaseEnterTheirDateOfBirth_dob2',
                    optional: true,
                    required: false,
                    halfWidth: false
                  },
                  {
                    label: 'please list the date of birth of your third child',
                    type: 'date',
                    name: 'doYouHaveOtherChildrenIfYesPleaseEnterTheirDateOfBirth_dob3',
                    optional: true,
                    required: false,
                    halfWidth: false
                  },
                  {
                    label: 'please list the date of birth of your fourth child',
                    type: 'date',
                    name: 'doYouHaveOtherChildrenIfYesPleaseEnterTheirDateOfBirth_dob4',
                    optional: true,
                    required: false,
                    halfWidth: false
                  },
                  {
                    label: 'please list the date of birth of your fifth child',
                    type: 'date',
                    name: 'doYouHaveOtherChildrenIfYesPleaseEnterTheirDateOfBirth_dob5',
                    optional: true,
                    required: false,
                    halfWidth: false
                  }
                ]
              }
            }
          ]
        },

        {
          label:
            'Do you feel you have adequate emotional support from your family and friends?',
          type: 'single_select',
          level: 'child',
          field:
            'doYouFeelYouHaveAdequateEmotionalSupportFromYourFamilyAndFriends',
          halfWidth: false,
          options: [
            {
              key: 'doYouFeelYouHaveAdequateEmotionalSupportFromYourFamilyAndFriends_always',
              value: 'Always - I consistently feel supported.'
            },
            {
              key: 'doYouFeelYouHaveAdequateEmotionalSupportFromYourFamilyAndFriends_usually',
              value: 'Usually - I feel supported most of the time.'
            },
            {
              key: 'doYouFeelYouHaveAdequateEmotionalSupportFromYourFamilyAndFriends_sometimes',
              value: 'Sometimes - I feel supported some of the time.'
            },
            {
              key: 'doYouFeelYouHaveAdequateEmotionalSupportFromYourFamilyAndFriends_rarely',
              value: 'Rarely - I seldom feel supported.'
            },
            {
              key: 'doYouFeelYouHaveAdequateEmotionalSupportFromYourFamilyAndFriends_never',
              value: 'Never - I do not feel supported at all.'
            }
          ]
        },

        {
          label: 'Are there any stressors in your home?',
          type: 'multi_select',
          level: 'child',
          field: 'areThereAnyStressorsInYourHome',
          halfWidth: false,
          options: [
            {
              key: 'areThereAnyStressorsInYourHome_separationDivorce',
              value: 'Separation/Divorce'
            },
            {
              key: 'areThereAnyStressorsInYourHome_ageingParents',
              value: 'Ageing Parents'
            },
            {
              key: 'areThereAnyStressorsInYourHome_legalProblems',
              value: 'Legal Problems'
            },
            {
              key: 'areThereAnyStressorsInYourHome_alcoholDrugAbuse',
              value: 'Alcohol/Drug Abuse'
            },
            {
              key: 'areThereAnyStressorsInYourHome_domesticViolence',
              value: 'Domestic Violence'
            },
            {
              key: 'areThereAnyStressorsInYourHome_unemployment',
              value: 'Unemployment'
            },
            {
              key: 'areThereAnyStressorsInYourHome_workProblems',
              value: 'Work Problems'
            },
            {
              key: 'areThereAnyStressorsInYourHome_childcare',
              value: 'Childcare'
            },
            {
              key: 'areThereAnyStressorsInYourHome_lossGrief',
              value: 'Loss/Grief'
            },
            {
              key: 'areThereAnyStressorsInYourHome_accidents',
              value: 'Accidents'
            },
            {
              key: 'areThereAnyStressorsInYourHome_longWorkHours',
              value: 'Long Work Hours'
            },
            {
              key: 'areThereAnyStressorsInYourHome_lackOfSupport',
              value: 'Lack of Support'
            },
            {
              key: 'areThereAnyStressorsInYourHome_newBaby',
              value: 'New Baby'
            },
            {
              key: 'areThereAnyStressorsInYourHome_financialStrain',
              value: 'Financial Strain'
            },
            {
              key: 'areThereAnyStressorsInYourHome_healthConcerns',
              value: 'Health Concerns'
            },
            {
              key: 'areThereAnyStressorsInYourHome_relationshipStrain',
              value: 'Relationship Strain'
            },
            {
              key: 'areThereAnyStressorsInYourHome_isolation',
              value: 'Isolation'
            },
            {
              key: 'areThereAnyStressorsInYourHome_workLifeDemands',
              value: 'Work-Life Demands'
            },
            {
              key: 'areThereAnyStressorsInYourHome_other',
              value: 'Other (Please specify)',
              answer: {
                type: 'text',
                rows: 3,
                name: 'areThereAnyStressorsInYourHomeOtherDesc',
                placeholder: ''
              }
            }
          ]
        },

        {
          label: 'Current Work Status',
          type: 'single_select',
          level: 'child',
          field: 'currentWorkStatus',
          halfWidth: false,
          required: true,
          optional: false,
          options: [
            {
              key: 'currentWorkStatus_Employed Full-time',
              value: 'Employed Full-time'
            },
            {
              key: 'currentWorkStatus_Employed Part-time',
              value: 'Employed Part-time'
            },
            {
              key: 'currentWorkStatus_Stay-at-Home Parent',
              value: 'Stay-at-Home Parent'
            },
            {
              key: 'currentWorkStatus_On Parental Leave',
              value: 'On Parental Leave'
            },
            {
              key: 'currentWorkStatus_Unemployed',
              value: 'Unemployed'
            },
            {
              key: 'currentWorkStatus_Student',
              value: 'Student'
            },
            {
              key: 'currentWorkStatus_Retired',
              value: 'Retired'
            },
            {
              key: 'currentWorkStatus_other',
              value: 'Other (Please specify)',
              answer: {
                type: 'text',
                rows: 3,
                name: 'currentWorkStatusOtherDesc',
                placeholder: ''
              }
            }
          ]
        },

        {
          label: 'Occupation',
          type: 'text',
          placeholder: '',
          name: 'occupation',
          optional: true,
          required: false,
          halfWidth: false
        }
      ]
    }
  },

  {
    label: 'Medical & Mental Health History',
    field: 'momwellPartnerHistoryFormMedicalMentalHealthHistory',
    type: 'info',
    answer: {
      type: 'list',
      items: [
        {
          label: 'Primary Doctor/Physician Name (if known)',
          type: 'text',
          placeholder: '',
          name: 'primaryDoctorPhysicianNameIfKnown',
          optional: true,
          required: false,
          halfWidth: false
        },
        {
          label: 'Primary Doctor/Physician Phone (if known)',
          type: 'text',
          placeholder: '',
          name: 'primaryDoctorPhysicianPhoneIfKnown',
          optional: true,
          required: false,
          halfWidth: false
        },
        {
          label: 'Primary Doctor/Physician Email (if known)',
          type: 'text',
          placeholder: '',
          name: 'primaryDoctorPhysicianEmailIfKnown',
          optional: true,
          required: false,
          halfWidth: false
        },

        {
          label: 'Are you currently receiving any medical care?',
          type: 'single_select',
          level: 'child',
          field: 'areYouCurrentlyReceivingAnyMedicalCare',
          halfWidth: false,
          options: [
            {
              key: 'areYouCurrentlyReceivingAnyMedicalCare_yes',
              value: 'Yes (Please specify)',
              answer: {
                type: 'text',
                rows: 3,
                name: 'areYouCurrentlyReceivingAnyMedicalCareYesDesc',
                placeholder: ''
              }
            },
            {
              key: 'areYouCurrentlyReceivingAnyMedicalCare_no',
              value: 'No'
            }
          ]
        },

        {
          label:
            'Please list any current medications (including non-prescription, supplements, etc)',
          type: 'text',
          placeholder: '',
          name: 'pleaseListAnyCurrentMedicationsIncludingNonPrescriptionSupplementsEtc',
          required: true,
          halfWidth: false
        },
        {
          label: 'Who is prescribing and overseeing your medications?',
          type: 'text',
          placeholder: '',
          name: 'whoIsPrescribingAndOverseeingYourMedications',
          optional: true,
          required: false,
          halfWidth: false
        },

        {
          label: 'Do you have any chronic health conditions?',
          type: 'single_select',
          level: 'child',
          field: 'doYouHaveAnyChronicHealthConditions',
          halfWidth: false,
          options: [
            {
              key: 'doYouHaveAnyChronicHealthConditions_yes',
              value: 'Yes (Please list them)',
              answer: {
                type: 'text',
                rows: 3,
                name: 'doYouHaveAnyChronicHealthConditionsYesDesc',
                placeholder: ''
              }
            },
            {
              key: 'doYouHaveAnyChronicHealthConditions_no',
              value: 'No'
            }
          ]
        },

        {
          label: 'Have you seen a mental health professional before?',
          type: 'single_select',
          level: 'child',
          field: 'haveYouSeenAMentalHealthProfessionalBefore',
          halfWidth: false,
          options: [
            {
              key: 'haveYouSeenAMentalHealthProfessionalBefore_yes',
              value: 'Yes (Please elaborate)',
              answer: {
                type: 'text',
                rows: 3,
                name: 'haveYouSeenAMentalHealthProfessionalBeforeYesDesc',
                placeholder: ''
              }
            },
            {
              key: 'haveYouSeenAMentalHealthProfessionalBefore_no',
              value: 'No'
            }
          ]
        },

        {
          label: 'Have you ever been diagnosed with a mental health condition?',
          type: 'single_select',
          level: 'child',
          field: 'haveYouEverBeenDiagnosedWithAMentalHealthCondition',
          halfWidth: false,
          options: [
            {
              key: 'haveYouEverBeenDiagnosedWithAMentalHealthCondition_yes',
              value: 'Yes (Please elaborate)',
              answer: {
                type: 'text',
                rows: 3,
                name: 'haveYouEverBeenDiagnosedWithAMentalHealthConditionYesDesc',
                placeholder: ''
              }
            },
            {
              key: 'haveYouEverBeenDiagnosedWithAMentalHealthCondition_no',
              value: 'No'
            }
          ]
        },

        {
          label:
            'Have you experienced any of the following? (Select all that apply)',
          type: 'multi_select',
          level: 'child',
          field: 'haveYouExperiencedAnyOfTheFollowingSelectAllThatApply',
          halfWidth: false,
          options: [
            {
              key: 'haveYouExperiencedAnyOfTheFollowingSelectAllThatApply_emotionalOrVerbalAbuse',
              value: 'Emotional or verbal abuse'
            },
            {
              key: 'haveYouExperiencedAnyOfTheFollowingSelectAllThatApply_sexualAbuse',
              value: 'Sexual abuse'
            },
            {
              key: 'haveYouExperiencedAnyOfTheFollowingSelectAllThatApply_physicalAbuse',
              value: 'Physical abuse'
            },
            {
              key: 'haveYouExperiencedAnyOfTheFollowingSelectAllThatApply_neglect',
              value: 'Neglect'
            },
            {
              key: 'haveYouExperiencedAnyOfTheFollowingSelectAllThatApply_witnessingViolenceDomesticCommunityWar',
              value: 'Witnessing violence (domestic, community, war)'
            },
            {
              key: 'haveYouExperiencedAnyOfTheFollowingSelectAllThatApply_lossOfALovedOneDeathSeparationAbandonment',
              value: 'Loss of a loved one (death, separation, abandonment)'
            },
            {
              key: 'haveYouExperiencedAnyOfTheFollowingSelectAllThatApply_medicalTraumaSeriousIllnessInjuryHospitalization',
              value: 'Medical trauma (serious illness, injury, hospitalization)'
            },
            {
              key: 'haveYouExperiencedAnyOfTheFollowingSelectAllThatApply_militaryCombatIfApplicable',
              value: 'Military combat (if applicable)'
            },
            {
              key: 'haveYouExperiencedAnyOfTheFollowingSelectAllThatApply_none',
              value: 'None of the above'
            },

            {
              key: 'haveYouExperiencedAnyOfTheFollowingSelectAllThatApply_other',
              value: 'Other (Please specify)',
              answer: {
                type: 'text',
                rows: 3,
                name: 'haveYouExperiencedAnyOfTheFollowingSelectAllThatApplyOtherDesc',
                placeholder: ''
              }
            }
          ]
        }
      ]
    }
  },

  {
    label: 'Reproductive Health',
    field: 'momwellPartnerHistoryFormReproductiveHealth',
    type: 'info',
    answer: {
      type: 'list',
      items: [
        {
          label: 'Have you or your partner had trouble conceiving?',
          type: 'single_select',
          level: 'child',
          field: 'haveYouHadTroubleConceiving',
          halfWidth: false,
          options: [
            {
              key: 'haveYouHadTroubleConceiving_currentlyStrugglingToConceive',
              value: 'Currently struggling to conceive'
            },
            {
              key: 'haveYouHadTroubleConceiving_previouslyStruggledToConceive',
              value: 'Previously struggled to conceive'
            },
            {
              key: 'haveYouHadTroubleConceiving_no',
              value: 'No'
            },
            {
              key: 'haveYouHadTroubleConceiving_preferNotToSay',
              value: 'Prefer not to say'
            }
          ]
        },
        {
          label:
            'Are you or your partner currently pregnant? If so, how far along?',
          type: 'single_select',
          level: 'child',
          field: 'areYouCurrentlyPregnantIfSoHowFarAlong',
          halfWidth: false,
          options: [
            {
              key: 'areYouCurrentlyPregnantIfSoHowFarAlong_notCurrentlyPregnant',
              value: 'Not currently pregnant'
            },
            {
              key: 'areYouCurrentlyPregnantIfSoHowFarAlong_firstTrimester',
              value: 'First trimester'
            },
            {
              key: 'areYouCurrentlyPregnantIfSoHowFarAlong_secondTrimester',
              value: 'Second trimester'
            },
            {
              key: 'areYouCurrentlyPregnantIfSoHowFarAlong_thirdTrimester',
              value: 'Third trimester'
            }
          ]
        },
        {
          label: 'Number of past pregnancies in your partnership:',
          type: 'single_select',
          level: 'child',
          field: 'numberOfPastPregnancies',
          halfWidth: false,
          options: [
            {
              key: 'numberOfPastPregnancies_0',
              value: '0'
            },
            {
              key: 'numberOfPastPregnancies_1',
              value: '1'
            },
            {
              key: 'numberOfPastPregnancies_2',
              value: '2'
            },
            {
              key: 'numberOfPastPregnancies_3',
              value: '3'
            },
            {
              key: 'numberOfPastPregnancies_4',
              value: '4'
            },
            {
              key: 'numberOfPastPregnancies_5',
              value: '5+'
            }
          ]
        },

        {
          label:
            'Outcomes of past pregnancies in your partnership. Check all that apply:',
          type: 'multi_select',
          level: 'child',
          field: 'outcomesOfPastPregnanciesCheckAllThatApply',
          halfWidth: false,
          options: [
            {
              key: 'outcomesOfPastPregnanciesCheckAllThatApply_noPastPregnancies',
              value: 'No past pregnancies'
            },
            {
              key: 'outcomesOfPastPregnanciesCheckAllThatApply_liveBirth',
              value: 'Live birth'
            },
            {
              key: 'outcomesOfPastPregnanciesCheckAllThatApply_miscarriage',
              value: 'Miscarriage'
            },
            {
              key: 'outcomesOfPastPregnanciesCheckAllThatApply_stillbirth',
              value: 'Stillbirth'
            },
            {
              key: 'outcomesOfPastPregnanciesCheckAllThatApply_termination',
              value: 'Termination'
            }
          ]
        },
        {
          label:
            'Any complications in previous pregnancies or deliveries in your partnership?',
          type: 'multi_select',
          level: 'child',
          field: 'anyComplicationsInPreviousPregnanciesOrDeliveries',
          halfWidth: false,
          options: [
            {
              key: 'anyComplicationsInPreviousPregnanciesOrDeliveries_highRiskPregnancy',
              value: 'High-risk pregnancy'
            },
            {
              key: 'anyComplicationsInPreviousPregnanciesOrDeliveries_nicuStay',
              value: 'NICU stay'
            },
            {
              key: 'anyComplicationsInPreviousPregnanciesOrDeliveries_birthTrauma',
              value: 'Birth trauma (e.g., forceps, vacuum, emergency cesarean)'
            },
            {
              key: 'anyComplicationsInPreviousPregnanciesOrDeliveries_prematureBirth',
              value: 'Premature birth'
            },
            {
              key: 'anyComplicationsInPreviousPregnanciesOrDeliveries_gestationalDiabetes',
              value: 'Gestational diabetes'
            },
            {
              key: 'anyComplicationsInPreviousPregnanciesOrDeliveries_preeclampsia',
              value: 'Preeclampsia'
            },
            {
              key: 'anyComplicationsInPreviousPregnanciesOrDeliveries_infectionsDuringPregnancy',
              value: 'Infections during pregnancy'
            },
            {
              key: 'anyComplicationsInPreviousPregnanciesOrDeliveries_perinatalMoodOrAnxietyDisorder',
              value: 'Perinatal mood or anxiety disorder'
            },
            {
              key: 'anyComplicationsInPreviousPregnanciesOrDeliveries_other',
              value: 'Other (Please specify)',
              answer: {
                type: 'text',
                rows: 3,
                name: 'anyComplicationsInPreviousPregnanciesOrDeliveriesOtherDesc',
                placeholder: ''
              }
            }
          ]
        }
      ]
    }
  },
  {
    label: 'Reason for Seeking Therapy',
    field: 'momwellPartnerHistoryFormReasonForSeekingTherapy',
    type: 'info',
    answer: {
      type: 'list',
      items: [
        {
          label:
            'What brings you to therapy at this time? Please be as detailed as possible',
          type: 'text',
          rows: 3,
          placeholder: '',
          name: 'whatBringsYouToTherapyAtThisTimePleaseBeAsDetailedAsPossible',
          optional: true,
          required: false
        },
        {
          label:
            'Please check any of the symptoms you have experienced in the past 6 months',
          type: 'multi_select',
          level: 'child',
          field:
            'pleaseCheckAnyOfTheSymptomsYouHaveExperiencedInThePast6Months',
          halfWidth: false,
          options: [
            {
              key: 'pleaseCheckAnyOfTheSymptomsYouHaveExperiencedInThePast6Months_depressedMood',
              value: 'Depressed mood'
            },
            {
              key: 'pleaseCheckAnyOfTheSymptomsYouHaveExperiencedInThePast6Months_tearfulOrCryingSpells',
              value: 'Tearful or crying spells'
            },
            {
              key: 'pleaseCheckAnyOfTheSymptomsYouHaveExperiencedInThePast6Months_anxiety',
              value: 'Anxiety'
            },
            {
              key: 'pleaseCheckAnyOfTheSymptomsYouHaveExperiencedInThePast6Months_fear',
              value: 'Fear'
            },
            {
              key: 'pleaseCheckAnyOfTheSymptomsYouHaveExperiencedInThePast6Months_hopelessness',
              value: 'Hopelessness'
            },
            {
              key: 'pleaseCheckAnyOfTheSymptomsYouHaveExperiencedInThePast6Months_panic',
              value: 'Panic'
            },
            {
              key: 'pleaseCheckAnyOfTheSymptomsYouHaveExperiencedInThePast6Months_irritability',
              value: 'Irritability'
            },
            {
              key: 'pleaseCheckAnyOfTheSymptomsYouHaveExperiencedInThePast6Months_momRage',
              value: 'Mom Rage'
            },
            {
              key: 'pleaseCheckAnyOfTheSymptomsYouHaveExperiencedInThePast6Months_lowSelfEsteem',
              value: 'Low self-esteem'
            },
            {
              key: 'pleaseCheckAnyOfTheSymptomsYouHaveExperiencedInThePast6Months_moodSwings',
              value: 'Mood swings'
            },
            {
              key: 'pleaseCheckAnyOfTheSymptomsYouHaveExperiencedInThePast6Months_feelingsOfOverwhelm',
              value: 'Feelings of overwhelm'
            },
            {
              key: 'pleaseCheckAnyOfTheSymptomsYouHaveExperiencedInThePast6Months_guilt',
              value: 'Guilt'
            },
            {
              key: 'pleaseCheckAnyOfTheSymptomsYouHaveExperiencedInThePast6Months_troubleConcentrating',
              value: 'Trouble concentrating'
            },
            {
              key: 'pleaseCheckAnyOfTheSymptomsYouHaveExperiencedInThePast6Months_racingThoughts',
              value: 'Racing thoughts'
            },
            {
              key: 'pleaseCheckAnyOfTheSymptomsYouHaveExperiencedInThePast6Months_intrusiveThoughts',
              value: 'Intrusive thoughts'
            },
            {
              key: 'pleaseCheckAnyOfTheSymptomsYouHaveExperiencedInThePast6Months_badDreamsNightmares',
              value: 'Bad dreams/Nightmares'
            },
            {
              key: 'pleaseCheckAnyOfTheSymptomsYouHaveExperiencedInThePast6Months_lossOfInterestInActivities',
              value: 'Loss of interest in activities'
            },
            {
              key: 'pleaseCheckAnyOfTheSymptomsYouHaveExperiencedInThePast6Months_memoryProblems',
              value: 'Memory problems'
            },
            {
              key: 'pleaseCheckAnyOfTheSymptomsYouHaveExperiencedInThePast6Months_indecisiveness',
              value: 'Indecisiveness'
            },
            {
              key: 'pleaseCheckAnyOfTheSymptomsYouHaveExperiencedInThePast6Months_obsessiveThoughts',
              value: 'Obsessive thoughts'
            },
            {
              key: 'pleaseCheckAnyOfTheSymptomsYouHaveExperiencedInThePast6Months_increasedAppetite',
              value: 'Increased appetite'
            },
            {
              key: 'pleaseCheckAnyOfTheSymptomsYouHaveExperiencedInThePast6Months_decreasedAppetite',
              value: 'Decreased appetite'
            },
            {
              key: 'pleaseCheckAnyOfTheSymptomsYouHaveExperiencedInThePast6Months_difficultySleeping',
              value: 'Difficulty sleeping'
            },
            {
              key: 'pleaseCheckAnyOfTheSymptomsYouHaveExperiencedInThePast6Months_excessiveSleep',
              value: 'Excessive sleep'
            },
            {
              key: 'pleaseCheckAnyOfTheSymptomsYouHaveExperiencedInThePast6Months_fatigueLowEnergy',
              value: 'Fatigue/low energy'
            },
            {
              key: 'pleaseCheckAnyOfTheSymptomsYouHaveExperiencedInThePast6Months_headaches',
              value: 'Headaches'
            },
            {
              key: 'pleaseCheckAnyOfTheSymptomsYouHaveExperiencedInThePast6Months_gastrointestinalIssues',
              value:
                'Gastrointestinal issues (e.g., nausea, diarrhea, constipation)'
            },
            {
              key: 'pleaseCheckAnyOfTheSymptomsYouHaveExperiencedInThePast6Months_somaticPains',
              value: 'Somatic pains (unexplained body pains)'
            },
            {
              key: 'pleaseCheckAnyOfTheSymptomsYouHaveExperiencedInThePast6Months_changeInLibido',
              value: 'Change in libido'
            },
            {
              key: 'pleaseCheckAnyOfTheSymptomsYouHaveExperiencedInThePast6Months_isolationFromOthers',
              value: 'Isolation from others'
            },
            {
              key: 'pleaseCheckAnyOfTheSymptomsYouHaveExperiencedInThePast6Months_lowMotivation',
              value: 'Low motivation'
            },
            {
              key: 'pleaseCheckAnyOfTheSymptomsYouHaveExperiencedInThePast6Months_withdrawalFromSocialActivities',
              value: 'Withdrawal from social activities'
            },
            {
              key: 'pleaseCheckAnyOfTheSymptomsYouHaveExperiencedInThePast6Months_strainInPersonalRelationships',
              value: 'Strain in personal relationships'
            },
            {
              key: 'pleaseCheckAnyOfTheSymptomsYouHaveExperiencedInThePast6Months_difficultyBondingWithTheBabyOrOtherChildrenIfApplicable',
              value:
                'Difficulty bonding with the baby or other children (if applicable)'
            }
          ]
        },
        {
          label: 'How long have the symptoms been occurring?',
          type: 'single_select',
          level: 'child',
          field: 'howLongHaveTheSymptomsBeenOccurring',
          halfWidth: false,
          options: [
            {
              key: 'howLongHaveTheSymptomsBeenOccurring_lessThan1Month',
              value: 'Less than 1 month'
            },
            {
              key: 'howLongHaveTheSymptomsBeenOccurring_1To3Months',
              value: '1-3 months'
            },
            {
              key: 'howLongHaveTheSymptomsBeenOccurring_3To6Months',
              value: '3-6 months'
            },
            {
              key: 'howLongHaveTheSymptomsBeenOccurring_moreThan6Months',
              value: 'More than 6 months'
            }
          ]
        },
        {
          label: 'When did they start',
          type: 'date',
          placeholder: '',
          name: 'whenDidTheyStart',
          required: true,
          halfWidth: true
        },
        {
          label:
            'What coping strategies or supports do you currently use when experiencing these symptoms?',
          type: 'multi_select',
          level: 'child',
          field:
            'whatCopingStrategiesOrSupportsDoYouCurrentlyUseWhenExperiencingTheseSymptoms',
          halfWidth: false,
          options: [
            {
              key: 'whatCopingStrategiesOrSupportsDoYouCurrentlyUseWhenExperiencingTheseSymptoms_exerciseRegularPhysicalActivity',
              value: ' Exercise (regular physical activity)'
            },
            {
              key: 'whatCopingStrategiesOrSupportsDoYouCurrentlyUseWhenExperiencingTheseSymptoms_relaxationTechniquesDeepBreathingMeditationYoga',
              value: 'Relaxation techniques (deep breathing, meditation, yoga)'
            },
            {
              key: 'whatCopingStrategiesOrSupportsDoYouCurrentlyUseWhenExperiencingTheseSymptoms_prioritzingSleep',
              value: 'Prioritzing sleep'
            },
            {
              key: 'whatCopingStrategiesOrSupportsDoYouCurrentlyUseWhenExperiencingTheseSymptoms_prioritizingNutrition',
              value: 'Prioritizing nutrition'
            },
            {
              key: 'whatCopingStrategiesOrSupportsDoYouCurrentlyUseWhenExperiencingTheseSymptoms_journaling',
              value: 'Journaling'
            },
            {
              key: 'whatCopingStrategiesOrSupportsDoYouCurrentlyUseWhenExperiencingTheseSymptoms_mindfulnessExercises',
              value: 'Mindfulness exercises'
            },
            {
              key: 'whatCopingStrategiesOrSupportsDoYouCurrentlyUseWhenExperiencingTheseSymptoms_artTherapyCreativeExpression',
              value: 'Art therapy/creative expression'
            },
            {
              key: 'whatCopingStrategiesOrSupportsDoYouCurrentlyUseWhenExperiencingTheseSymptoms_spendingTimeInNature',
              value: 'Spending time in nature'
            },
            {
              key: 'whatCopingStrategiesOrSupportsDoYouCurrentlyUseWhenExperiencingTheseSymptoms_listeningToCalmingMusic',
              value: 'Listening to calming music'
            },
            {
              key: 'whatCopingStrategiesOrSupportsDoYouCurrentlyUseWhenExperiencingTheseSymptoms_talkingToATrustedFriendOrFamilyMember',
              value: 'Talking to a trusted friend or family member'
            },
            {
              key: 'whatCopingStrategiesOrSupportsDoYouCurrentlyUseWhenExperiencingTheseSymptoms_supportGroupsOnlineOrInPerson',
              value: 'Support groups (online or in-person)'
            },
            {
              key: 'whatCopingStrategiesOrSupportsDoYouCurrentlyUseWhenExperiencingTheseSymptoms_therapyIndividualOrCouples',
              value: 'Therapy (individual or couples)'
            },
            {
              key: 'whatCopingStrategiesOrSupportsDoYouCurrentlyUseWhenExperiencingTheseSymptoms_connectingWithOtherMothers',
              value: 'Connecting with other mothers'
            },
            {
              key: 'whatCopingStrategiesOrSupportsDoYouCurrentlyUseWhenExperiencingTheseSymptoms_timeManagementSkills',
              value: 'Time management skills'
            },
            {
              key: 'whatCopingStrategiesOrSupportsDoYouCurrentlyUseWhenExperiencingTheseSymptoms_settingRealisticGoalsAndBoundaries',
              value: 'Setting realistic goals and boundaries'
            },
            {
              key: 'whatCopingStrategiesOrSupportsDoYouCurrentlyUseWhenExperiencingTheseSymptoms_askingForHelpWhenNeeded',
              value: 'Asking for help when needed'
            },
            {
              key: 'whatCopingStrategiesOrSupportsDoYouCurrentlyUseWhenExperiencingTheseSymptoms_adjustingExpectations',
              value: 'Adjusting expectations'
            },
            {
              key: 'whatCopingStrategiesOrSupportsDoYouCurrentlyUseWhenExperiencingTheseSymptoms_seekingProfessionalSupport',
              value:
                'Seeking professional support (parenting classes, lactation support, etc.)'
            },
            {
              key: 'whatCopingStrategiesOrSupportsDoYouCurrentlyUseWhenExperiencingTheseSymptoms_other',
              value: 'Other (please specify)',
              answer: {
                type: 'text',
                rows: 3,
                name: 'whatCopingStrategiesOrSupportsDoYouCurrentlyUseWhenExperiencingTheseSymptomsOtherDesc',
                placeholder: ''
              }
            }
          ]
        },
        {
          label: 'How often do you drink alcohol?',
          type: 'single_select',
          level: 'child',
          field: 'howOftenDoYouDrinkAlcohol',
          halfWidth: false,
          options: [
            {
              key: 'howOftenDoYouDrinkAlcohol_daily',
              value: 'Daily'
            },
            {
              key: 'howOftenDoYouDrinkAlcohol_severalTimesAWeek',
              value: 'Several times a week'
            },
            {
              key: 'howOftenDoYouDrinkAlcohol_onceAWeek',
              value: 'Once a week'
            },
            {
              key: 'howOftenDoYouDrinkAlcohol_aFewTimesAMonth',
              value: 'A few times a month'
            },
            {
              key: 'howOftenDoYouDrinkAlcohol_rarely',
              value: 'Rarely'
            },
            {
              key: 'howOftenDoYouDrinkAlcohol_never',
              value: 'Never'
            }
          ]
        },
        {
          label: 'How often do you use recreational drugs?',
          type: 'single_select',
          level: 'child',
          field: 'howOftenDoYouUseRecreationalDrugs',
          halfWidth: false,
          options: [
            {
              key: 'howOftenDoYouUseRecreationalDrugs_daily',
              value: 'Daily'
            },
            {
              key: 'howOftenDoYouUseRecreationalDrugs_severalTimesAWeek',
              value: 'Several times a week'
            },
            {
              key: 'howOftenDoYouUseRecreationalDrugs_onceAWeek',
              value: 'Once a week'
            },
            {
              key: 'howOftenDoYouUseRecreationalDrugs_aFewTimesAMonth',
              value: 'A few times a month'
            },
            {
              key: 'howOftenDoYouUseRecreationalDrugs_rarely',
              value: 'Rarely'
            },
            {
              key: 'howOftenDoYouUseRecreationalDrugs_never',
              value: 'Never'
            }
          ]
        },
        {
          label: 'How often do you smoke?',
          type: 'single_select',
          level: 'child',
          field: 'howOftenDoYouSmoke',
          halfWidth: false,
          options: [
            {
              key: 'howOftenDoYouSmoke_daily',
              value: 'Daily'
            },
            {
              key: 'howOftenDoYouSmoke_severalTimesAWeek',
              value: 'Several times a week'
            },
            {
              key: 'howOftenDoYouSmoke_onceAWeek',
              value: 'Once a week'
            },
            {
              key: 'howOftenDoYouSmoke_aFewTimesAMonth',
              value: 'A few times a month'
            },
            {
              key: 'howOftenDoYouSmoke_rarely',
              value: 'Rarely'
            },
            {
              key: 'howOftenDoYouSmoke_never',
              value: 'Never'
            }
          ]
        },
        {
          label: 'What do you hope to achieve through therapy?',
          type: 'text',
          placeholder: '',
          name: 'whatDoYouHopeToAchieveThroughTherapy',
          optional: true,
          required: false
        }
      ]
    }
  },
  {
    label: 'Safety and Legal Considerations',
    field: 'momwellPartnerHistoryFormSafetyAndLegalConsiderations',
    type: 'info',
    answer: {
      type: 'list',
      items: [
        {
          label: 'Do you have suicidal thoughts?',
          type: 'single_select',
          level: 'child',
          field: 'doYouHaveSuicidalThoughts',
          halfWidth: false,
          options: [
            {
              key: 'doYouHaveSuicidalThoughts_daily',
              value: 'Daily'
            },
            {
              key: 'doYouHaveSuicidalThoughts_severalTimesAWeek',
              value: 'Several times a week'
            },
            {
              key: 'doYouHaveSuicidalThoughts_onceAWeek',
              value: 'Once a week'
            },
            {
              key: 'doYouHaveSuicidalThoughts_aFewTimesAMonth',
              value: 'A few times a month'
            },
            {
              key: 'doYouHaveSuicidalThoughts_rarely',
              value: 'Rarely'
            },
            {
              key: 'doYouHaveSuicidalThoughts_never',
              value: 'Never'
            }
          ]
        },

        {
          label: 'Have you ever attempted suicide?',
          type: 'single_select',
          level: 'child',
          field: 'haveYouEverAttemptedSuicide',
          halfWidth: false,
          options: [
            {
              key: 'haveYouEverAttemptedSuicide_yes',
              value: 'Yes (Please elaborate)',
              answer: {
                type: 'text',
                rows: 3,
                name: 'haveYouEverAttemptedSuicideYesDesc',
                placeholder: ''
              }
            },
            {
              key: 'haveYouEverAttemptedSuicide_no',
              value: 'No'
            }
          ]
        },

        {
          label: 'Do you have thoughts or urges to harm others?',
          type: 'single_select',
          level: 'child',
          field: 'doYouHaveThoughtsOrUrgesToHarmOthers',
          halfWidth: false,
          options: [
            {
              key: 'doYouHaveThoughtsOrUrgesToHarmOthers_daily',
              value: 'Daily'
            },
            {
              key: 'doYouHaveThoughtsOrUrgesToHarmOthers_severalTimesAWeek',
              value: 'Several times a week'
            },
            {
              key: 'doYouHaveThoughtsOrUrgesToHarmOthers_onceAWeek',
              value: 'Once a week'
            },
            {
              key: 'doYouHaveThoughtsOrUrgesToHarmOthers_aFewTimesAMonth',
              value: 'A few times a month'
            },
            {
              key: 'doYouHaveThoughtsOrUrgesToHarmOthers_rarely',
              value: 'Rarely'
            },
            {
              key: 'doYouHaveThoughtsOrUrgesToHarmOthers_never',
              value: 'Never'
            }
          ]
        },

        {
          label: 'Have you ever been hospitalized for mental health struggles?',
          type: 'single_select',
          level: 'child',
          field: 'haveYouEverBeenHospitalizedForMentalHealthStruggles',
          halfWidth: false,
          options: [
            {
              key: 'haveYouEverBeenHospitalizedForMentalHealthStruggles_yes',
              value: 'Yes (Please elaborate)',
              answer: {
                type: 'text',
                rows: 3,
                name: 'haveYouEverBeenHospitalizedForMentalHealthStrugglesYesDesc',
                placeholder: ''
              }
            },
            {
              key: 'haveYouEverBeenHospitalizedForMentalHealthStruggles_no',
              value: 'No'
            }
          ]
        },
        {
          label: 'Are you currently in any legal battles?',
          type: 'single_select',
          level: 'child',
          field: 'areYouCurrentlyInAnyLegalBattles',
          halfWidth: false,
          options: [
            {
              key: 'areYouCurrentlyInAnyLegalBattles_yes',
              value: 'Yes (Please elaborate)',
              answer: {
                type: 'text',
                rows: 3,
                name: 'areYouCurrentlyInAnyLegalBattlesYesDesc',
                placeholder: ''
              }
            },
            {
              key: 'areYouCurrentlyInAnyLegalBattles_no',
              value: 'No'
            }
          ]
        },
        {
          label:
            'Do you have any outstanding charges? (Note: services cannot be used to mitigate charges related to intimate partner violence)',
          type: 'single_select',
          level: 'child',
          field:
            'doYouHaveAnyOutstandingChargesNoteServicesCannotBeUsedToMitigateChargesRelatedToIntimatePartnerViolence',
          halfWidth: false,
          options: [
            {
              key: 'doYouHaveAnyOutstandingChargesNoteServicesCannotBeUsedToMitigateChargesRelatedToIntimatePartnerViolence_yes',
              value: 'Yes (Please elaborate)',
              answer: {
                type: 'text',
                rows: 3,
                name: 'doYouHaveAnyOutstandingChargesNoteServicesCannotBeUsedToMitigateChargesRelatedToIntimatePartnerViolenceYesDesc',
                placeholder: ''
              }
            },
            {
              key: 'doYouHaveAnyOutstandingChargesNoteServicesCannotBeUsedToMitigateChargesRelatedToIntimatePartnerViolence_no',
              value: 'No'
            }
          ]
        },
        {
          label: 'Is/has the child protective services been involved?',
          type: 'single_select',
          level: 'child',
          field: 'isHasTheChildProtectiveServicesBeenInvolved',
          halfWidth: false,
          options: [
            {
              key: 'isHasTheChildProtectiveServicesBeenInvolved_yes',
              value: 'Yes (Please elaborate)',
              answer: {
                type: 'text',
                rows: 3,
                name: 'isHasTheChildProtectiveServicesBeenInvolvedYesDesc',
                placeholder: ''
              }
            },
            {
              key: 'isHasTheChildProtectiveServicesBeenInvolved_no',
              value: 'No'
            }
          ]
        }
      ]
    }
  }
];

export default questionsModels;
